type TopChallengerProps = {
  labels: string[];
  data: number[];
};

import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from "chart.js";

// ✅ Don't forget LinearScale for horizontal charts
ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const TopChallenger = ({ labels, data }: TopChallengerProps) => {
  const barData = {
    labels: labels,
    datasets: [
      {
        data: data,
        backgroundColor: [
          "#dd5325",
          "#fb6fbb",
          "#fcc64a",
          "#70af3f",
          "#498fff",
        ],
        borderColor: ["#dd5325", "#fb6fbb", "#fcc64a", "#70af3f", "#498fff"],
        borderWidth: 1,
        borderRadius: 10,
      },
    ],
  };

  const options = {
    responsive: true,
    indexAxis: "y" as const,
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          font: {
            family: `"Nunito", sans-serif`,
          },
        },
      },
      y: {
        grid: {
          display: false,
        },
        ticks: {
          stepSize: 20,
          font: {
            family: `"Nunito", sans-serif`,
          },
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        titleFont: {
          family: `"Nunito", sans-serif`,
        },
        bodyFont: {
          family: `"Nunito", sans-serif`,
        },
      },
      datalabels: { display: false },
    },
  };

  return (
    <article className="w-full lg:w-1/2">
      <div className="mb-4 flex items-center relative top-challenger-title">
        <h3 className="text-[20px] font-bold me-2">This Week’s Top Readers</h3>
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="#498fff"
            version="1.1"
            id="Capa_1"
            width="20px"
            height="20px"
            viewBox="0 0 552.855 552.855"
          >
            <g>
              <g>
                <path d="M511.9,157.425c-3.408-25.845-17.057-53.513-40-76.463c-22.943-22.944-50.605-36.585-76.445-39.994    c-11.695-1.542-27.307-8.005-36.664-15.184C338.1,9.915,308.889,0,276.434,0s-61.665,9.915-82.351,25.784    c-9.357,7.179-24.97,13.642-36.665,15.184c-25.845,3.409-53.501,17.05-76.445,39.994c-22.944,22.95-36.592,50.619-40,76.463    c-1.536,11.695-8.005,27.295-15.178,36.653c-15.875,20.686-25.79,49.896-25.79,82.35c0,32.455,9.915,61.666,25.784,82.352    c7.179,9.357,13.642,24.963,15.178,36.652c3.409,25.844,17.056,53.514,40,76.463c22.944,22.943,50.606,36.586,76.445,39.994    c11.695,1.543,27.308,8.006,36.665,15.184c20.686,15.869,49.896,25.783,82.351,25.783c32.455,0,61.666-9.914,82.352-25.783    c9.357-7.178,24.969-13.641,36.664-15.184c25.846-3.408,53.502-17.051,76.445-39.994c22.943-22.949,36.592-50.619,40-76.463    c1.537-11.695,8.006-27.295,15.178-36.652c15.869-20.686,25.783-49.896,25.783-82.352c0-32.454-9.914-61.665-25.783-82.35    C519.9,184.72,513.438,169.12,511.9,157.425z M309.525,433.191c0,6.764-5.484,12.24-12.24,12.24h-39.652    c-6.756,0-12.24-5.477-12.24-12.24v-39.65c0-6.764,5.483-12.24,12.24-12.24h39.652c6.756,0,12.24,5.477,12.24,12.24V433.191z     M384.502,243.674c-7.994,12.632-25.068,29.823-51.238,51.58c-13.543,11.26-21.951,20.312-25.221,27.16    c-2.447,5.135-3.904,13.305-4.344,24.51c-0.264,6.758-5.588,12.234-12.352,12.234h-33.72c-6.757,0-12.301-3.428-12.369-7.65    c-0.061-3.916-0.098-6.463-0.098-7.643c0-18.869,3.122-34.389,9.357-46.562c6.243-12.172,18.715-25.862,37.429-41.083    c18.717-15.214,29.896-25.184,33.545-29.896c5.631-7.454,8.445-15.673,8.445-24.651c0-12.479-4.975-23.164-14.945-32.069    c-9.969-8.904-23.391-13.354-40.281-13.354c-11.604,0-21.842,2.356-30.741,7.068c-5.973,3.164-14.406,10.355-18.476,15.753    c-4.541,6.022-8.219,13.268-11.034,21.738c-2.136,6.414-8.636,11.138-15.349,10.306l-34.584-4.29    c-6.714-0.833-11.897-6.995-10.698-13.648c3.978-22.032,15.098-41.114,33.354-57.24c21.53-19.021,49.792-28.531,84.786-28.531    c36.824,0,66.107,9.626,87.865,28.874c21.756,19.248,32.639,41.653,32.639,67.216    C396.484,217.658,392.488,231.048,384.502,243.674z" />
              </g>
            </g>
          </svg>
        </span>

        <div className="informational-msg-popup topchallenger-informational-msg-popup">
          The top 5 students who gained the most points
        </div>
      </div>
      <Bar data={barData} options={options} />
    </article>
  );
};

export default TopChallenger;
